import { Spin } from "antd";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router";
import DashAudioPlayer from "../../../components/JobModuleComponent/QCDetailPageComponent/AudioPlayerComponent/DashAudioPlayer";
import CompletedReviewModal from "../../../components/JobModuleComponent/QCDetailPageComponent/CompletedReviewModal/CompletedReviewModal";
import EditSpeakerModal from "../../../components/JobModuleComponent/QCDetailPageComponent/EditSpeakerModal/EditSpeakerModal";
import ExportModal from "../../../components/JobModuleComponent/QCDetailPageComponent/ExportModal/ExportModal";
import ControlPanel from "../../../components/JobModuleComponent/QCDetailPageComponent/FindReplaceComponent/ControlPanel";
import FindReplaceTextAreas from "../../../components/JobModuleComponent/QCDetailPageComponent/FindReplaceComponent/FindReplaceTextAreas";
import QcDetailAudioBlockDeleteModal from "../../../components/SharedComponent/ModalComponent/QcDetailAudioBlockDeleteModal";
import QcDetailDeleteModal from "../../../components/SharedComponent/ModalComponent/QcDetailDeleteModal";
import BackBtn from "../../../components/Template/Buttons/BackBtn";
import { useBindKeys } from "../../../hooks/useBindKeys";
import { clearMergeBlock, closeCompletedReviewModal, closeEditSpeakerModal, closeExportModal, closeFindReplace, closeQcDetailAudioBlockDeleteModal, closeQcDetailDeleteModal, createNewSegment, fetchDetailPack, handleMergeBlock, openCompletedReviewModal, openEditSpeakerModal, openExportModal, openFindReplace, openQcDetailAudioBlockDeleteModal, openQcDetailDeleteModal, reopenForPreview, resetQCDetailPage, setCurrentFocusBlockIndex, setSelectedTranscriptionBlock } from "../../../redux/JobModule/QCDetailPage/QCDetailPageAction";
import { RootState } from "../../../redux/store"; // Adjust the path to your store file
import { useAppDispatch } from "../../../redux/useAppDispatch";
import { scrollIntoView } from "../../../utils/scrollIntoView";
import "./QCDetailPage.css";

function QCDetailPage(props: any) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  const loading = useSelector((state: RootState) => state.qCDetailPageState.loading);
  const packDetail = useSelector((state: RootState) => state.qCDetailPageState.data);
  const userEmail = useSelector((state: RootState) => state.TranscribeState.email);
  const findReplaceOpenState = useSelector((state: RootState) => state.qCDetailPageState.openFindReplaceState);
  const exportModalState = useSelector((state: RootState) => state.qCDetailPageState.exportModalState);
  const deleteModalState = useSelector((state: RootState) => state.qCDetailPageState.deleteModalState);
  const openEditSpeakerModalState = useSelector((state: RootState) => state.qCDetailPageState.openEditSpeakerModal);
  const deleteAudioBlockModalState = useSelector((state: RootState) => state.qCDetailPageState.deleteAudioBlockModalState);
  const openFindReplaceState = useSelector((state: RootState) => state.qCDetailPageState.openFindReplaceState);
  const openCompletedReviewModalState = useSelector((state: RootState) => state.qCDetailPageState.openCompletedReviewModal);
  const currentActiveBlockIndex = useSelector((state: RootState) => state.qCDetailPageState.currentFocusBlockIndex);
  const currentBlock = packDetail.transcriptions ? packDetail.transcriptions[0].transcriptionBlocks[currentActiveBlockIndex] : null;
  const editorRef = React.useRef<any>(null);
  const backActionClick = () => {
     navigate(-1);
  };
  const location = useLocation();
  const id = location.pathname.split("/").pop();
  useEffect(() => {
    dispatch(fetchDetailPack(id));
    return () => {
      dispatch(resetQCDetailPage());
    };
  }, []);
  const handleAddBlock = async () => {
    const idTranscription = packDetail.transcriptions[0].idTranscription;
    const payload = {
      TranscriptionId: idTranscription,
      NewBlocks: [
        {
          StartTimeSec: currentBlock.startTimeSec,
          EndTimeSec: currentBlock.startTimeSec,
          Speaker: currentBlock.speaker,
          Text: "",
        },
      ],
      TranscriptionBlocks: [],
    };
    await dispatch(createNewSegment({ id: idTranscription, data: payload }));
  };

  const nextBlockKeyHandler = () => {
    if (currentActiveBlockIndex + 1 >= packDetail.transcriptions[0].transcriptionBlocks.length) {
      dispatch(setCurrentFocusBlockIndex(0));
      scrollIntoView(0, true);
      return;
    } else {
      dispatch(setCurrentFocusBlockIndex(currentActiveBlockIndex + 1));
      scrollIntoView(currentActiveBlockIndex + 1, true);
    }
  };
  const previousBlockKeyHandler = () => {
    if (currentActiveBlockIndex - 1 < 0) {
      const blockIndex = packDetail.transcriptions[0].transcriptionBlocks.length - 1;
      dispatch(setCurrentFocusBlockIndex(blockIndex));
      scrollIntoView(blockIndex, true);
      return;
    } else {
      dispatch(setCurrentFocusBlockIndex(currentActiveBlockIndex - 1));
      scrollIntoView(currentActiveBlockIndex - 1, true);
    }
  };

  useBindKeys(() => dispatch(handleMergeBlock(currentActiveBlockIndex)), ["KeyG"], [currentActiveBlockIndex], true, true);
  useBindKeys(() => dispatch(clearMergeBlock()), ["Escape"], [currentActiveBlockIndex], false, false);
  useBindKeys(() => nextBlockKeyHandler(), ["KeyN"], [currentActiveBlockIndex], true, true);
  useBindKeys(() => previousBlockKeyHandler(), ["KeyP"], [currentActiveBlockIndex], true, true);
  useBindKeys(() => handleAddBlock(), ["KeyA"], [currentActiveBlockIndex, packDetail, currentBlock], true, true);
  useBindKeys(
    () => {
      dispatch(openQcDetailAudioBlockDeleteModal());
      dispatch(setSelectedTranscriptionBlock(currentBlock.idTranscriptionBlock));
    },
    ["KeyD"],
    [currentActiveBlockIndex],
    true,
    true
  );

  // useEffect(() => {
  //   dispatch(emptyMergeBlock());
  // }, [packDetail]);
  // useNotification();
   const isLocked =
    packDetail.lockedToEmailAddress?.toLowerCase() ===
      userEmail?.toLowerCase() || packDetail.lockedToEmailAddress === "";

  if (loading) {
    return (
      <div
        className="app"
        style={{
          textAlign: "center",

          display: "flex",

          alignItems: "center",

          justifyContent: "center",
        }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div className="body-container">
      <EditSpeakerModal
        openState={openEditSpeakerModalState}
        open={() => dispatch(openEditSpeakerModal())}
        close={() => dispatch(closeEditSpeakerModal())}
      />
      <div className="d-flex align-items-center gap-3 justify-content-between">
        <div className="d-flex align-items-center gap-3">
          <BackBtn
            backActionClick={() => backActionClick()}
            backPath="/auth/inprogress"
          />

          <span className="title">{packDetail.fileName}</span>
          {!isLocked && <div className="lock-to-container">LOCKED TO {packDetail.lockedTo}</div>}
          {packDetail.createdBy && <span className="title-desc">Requestor: {packDetail.clientName}</span>}
          {packDetail.jobNumber && <span className="title-desc">Job Number: {packDetail.jobNumber}</span>}
          {packDetail.qcTime && <span className="title-desc">QC time spent:{packDetail.qcTime}</span>}
          <span className="title-desc">Time to transcribe: {new Date(packDetail.timeToAutoTranscribe * 1000).toISOString().substr(11, 8)}</span>
        </div>
        <div className="d-flex align-items-center gap-1">
          <button
            className="button btn-detailpage"
            onClick={() => {
              if (openFindReplaceState) {
                dispatch(closeFindReplace());
              } else {
                dispatch(openFindReplace());
              }
            }}>
            Find
          </button>

          {isLocked && packDetail.transcriptions[0].transcriptionType === "Transcription" && (
            <button
              className="button btn-detailpage"
              onClick={() => dispatch(openEditSpeakerModal())}>
              Edit Speakers
            </button>
          )}

          <button
            onClick={() => {
              dispatch(openExportModal());
            }}
            className="button btn-detailpage">
            Export
          </button>
          {isLocked && packDetail.processingStatus !== "ARCHIVED" && (
            <>
              {packDetail.processingStatus === "QC_COMPLETE" ? (
                <button
                  onClick={() => dispatch(reopenForPreview(packDetail.idPack))}
                  className="button">
                  Reopen for review
                </button>
              ) : (
                <button
                  className="button"
                  onClick={() => dispatch(openCompletedReviewModal())}>
                  Mark as complete
                </button>
              )}
              <button
                className="button danger"
                onClick={() => {
                  dispatch(openQcDetailDeleteModal());
                }}>
                Delete
              </button>
            </>
          )}
        </div>
      </div>
      {findReplaceOpenState && (
        <ControlPanel
          editorRef={editorRef}
          texts={packDetail.transcriptions[0].transcriptionBlocks}
          type={packDetail.transcriptions[0].transcriptionType}
        />
      )}
      <hr />
      <DashAudioPlayer src="https://dev.idp.wl-engage.com/audio/encoded/Williams_Lea/0cb565f0-d689-4b83-b4f2-900c072729a0/UKC-037488_SAT_PARTNER_V4.mpd" />
      <hr />
      <FindReplaceTextAreas
        texts={packDetail.transcriptions[0].transcriptionBlocks}
        speakers={packDetail.transcriptions[0].speakers}
        type={packDetail.transcriptions[0].transcriptionType}
        disabled={!isLocked}
        editorRef={editorRef}
        packId={Number(id)}
      />

      <CompletedReviewModal
        openState={openCompletedReviewModalState}
        open={() => dispatch(openCompletedReviewModal())}
        close={() => dispatch(closeCompletedReviewModal())}
      />
      <ExportModal
        openState={exportModalState}
        open={() => dispatch(openExportModal())}
        close={() => dispatch(closeExportModal())}
        packDetail={packDetail}
      />
      <QcDetailDeleteModal
        open={() => dispatch(openQcDetailDeleteModal())}
        close={() => dispatch(closeQcDetailDeleteModal())}
        openState={deleteModalState}
      />

      <QcDetailAudioBlockDeleteModal
        openState={deleteAudioBlockModalState}
        open={() => dispatch(openQcDetailAudioBlockDeleteModal())}
        close={() => dispatch(closeQcDetailAudioBlockDeleteModal())}
      />
    </div>
  );
}

export default QCDetailPage;
